// extracted by mini-css-extract-plugin
export default {"container":"AnnotationInput-module__container--MLQDX","animatedBackground":"AnnotationInput-module__animatedBackground--iSKd0"};